"use client"
/* */
const badge = "flow--badge";
const content = "flow--badge--content";
const button = "flow--badge--button";
const close = "flow--badge--close";
const scope = "flow--badge--scope";
const value = "flow--badge--value";
const neutral = "flow--badge--neutral";
const disabled = "flow--badge--disabled";
const blue = "flow--badge--blue";
const navy = "flow--badge--navy";
const violet = "flow--badge--violet";
const teal = "flow--badge--teal";
const lilac = "flow--badge--lilac";
const green = "flow--badge--green";
const orange = "flow--badge--orange";
const red = "flow--badge--red";
const dark = "flow--badge--dark";
const light = "flow--badge--light";
const styles = {
	badge: badge,
	content: content,
	button: button,
	close: close,
	scope: scope,
	value: value,
	neutral: neutral,
	disabled: disabled,
	blue: blue,
	navy: navy,
	violet: violet,
	teal: teal,
	lilac: lilac,
	green: green,
	orange: orange,
	red: red,
	dark: dark,
	light: light
};

export { badge, blue, button, close, content, dark, styles as default, disabled, green, light, lilac, navy, neutral, orange, red, scope, teal, value, violet };
//# sourceMappingURL=Badge.module.scss.mjs.map
